/**
 * Открывает вкладку сразу по клику, а адрес подставляет, когда он будет готов.
 * Если вызвать window.open после await, Safari и iOS блокируют его как всплывающее окно.
 */
const openAsyncUrlInNewTab = async (getUrl: () => Promise<string | undefined>) => {
  const newWindow = window.open('', '_blank');

  if (newWindow) {
    newWindow.opener = null;
  }

  try {
    const url = await getUrl();

    if (!url) {
      newWindow?.close();
      return;
    }

    if (!newWindow) {
      window.open(url, '_blank');
      return;
    }

    newWindow.location.href = url;
  } catch (e) {
    newWindow?.close();
    throw e;
  }
};

export default openAsyncUrlInNewTab;
